/**
 * Helpers for property (B&B / appartamento) UI tinting and keyword lookup.
 *
 * Why this file exists: properties are referenced in many places by a free-text
 * "client_filter" string (saved in DB possibly with arbitrary casing, e.g.
 * "GABBIANO"). We must match it case-insensitively against the official
 * `properties` collection (where each record has a `client_filter_keyword`
 * like "Gabbiano"). Without the helper, lookups quietly fail and the UI shows
 * the raw uppercase string instead of the human-readable "B&B Gabbiano".
 */

// Stable, host-approved color palette per property family:
//   Emmanuel    → orange
//   Gabbiano    → sky blue
//   Appartamento → green
// Custom property colors (saved in DB `properties.color`) take precedence.
export const propertyTone = (p) => {
  if (!p) return "#AC5D45";
  const slug = (p.slug || "").toLowerCase();
  const name = (p.name || "").toLowerCase();
  if (slug.includes("emmanuel") || name.includes("emmanuel")) return "#EA580C";
  if (slug.includes("gabbiano") || name.includes("gabbiano")) return "#38BDF8";
  if (slug.includes("appartamento") || slug.includes("apartment") ||
      name.includes("appartamento") || name.includes("elisa")) return "#16A34A";
  return p.color || "#AC5D45";
};

// Robust property lookup: matches a free-text keyword (whatever the user/excel
// uploaded) case-insensitively against the property's keyword OR the last
// token of its name (so "B&B Gabbiano" → "gabbiano" matches "GABBIANO").
export const findPropertyForKw = (properties, kw) => {
  if (!kw || !Array.isArray(properties)) return null;
  const target = String(kw).trim().toLowerCase();
  if (!target) return null;
  return properties.find((p) => {
    const pkw = String(p.client_filter_keyword || "").trim().toLowerCase();
    const tail = String(p.name || "").trim().split(/\s+/).pop().toLowerCase();
    return (pkw && pkw === target) || (tail && tail === target);
  }) || null;
};
